<script setup lang="ts"></script>
<template>
  <NuxtLayout>
    <p class="font-secondary text-center text-D-200 p-D-400">404</p>
  </NuxtLayout>
</template>
